export default __webpack_public_path__ + "static/media/1780.be415c9f.JPG";